module.exports = __webpack_public_path__ + "static/media/white-spinner.77d2bc0e.gif";